import React from 'react';
import { Modal, Button } from 'antd';
import ResponseDialog from 'components/ResponseDialog/ResponseDialog';
import alertClient from 'assets/images/alert_client.svg';

const ModalConfirmacionProduct = ({ openModal, onClose, onConfirm, message, logo, confirmText = 'Listo' }: any) => {
  return (
    <Modal
      width={'20vw'}
      centered
      open={openModal}
      bodyStyle={{
        padding: '20px'
      }}
      destroyOnClose
      maskClosable={false}
      onCancel={onClose}
      okButtonProps={{
        style: {
          display: 'none'
        }

      }}
      cancelButtonProps={{
        style: {
          display: 'none'
        }
      }}
    >
      <ResponseDialog
        colSpan={24}
        message={message}
        onClose={onClose}
        logo={logo ?? alertClient}
        options={[
          <div className='container-buttons'>
            <Button key="confirm" className='next-button' onClick={onConfirm}>
              {confirmText}
            </Button>
          </div>
        ]}
      />
    </Modal>
  );
};

export default ModalConfirmacionProduct;
